<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>New Region</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">What's the name of the Region?</div>
              <v-text-field
                v-model="name"
                hide-details
                dense
                outlined
                placeholder="Pin Name"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Latitude</div>
              <v-text-field
                v-model="latitude"
                hide-details
                dense
                outlined
                placeholder="Latitude"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Longitude</div>
              <v-text-field
                v-model="longitude"
                hide-details
                dense
                outlined
                placeholder="Logitude"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      name: "",
      latitude: "",
      longitude: "",
    };
  },
  computed: {
    changeFields() {
      return {
        name: this.name,
        latitude: this.latitude,
        longitude: this.longitude,
      };
    },
  },
  methods: {
    ...mapActions({
      createNewRegion: "$_home/createNewContent",
      getRegions: "$_home/getContent",
    }),
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    cancel() {
      this.name = "";
      this.latitude = "";
      this.longitude = "";
      this.dialog = false;
    },
    save() {
      console.log(this.changeFields);
      this.createNewRegion({
        details: this.changeFields,
        collection: "regions",
        type: "Region",
      }).then(() => {
        this.dialog = false;
        this.getRegions({ collection: "regions", mutation: "updateRegions" });
      });
    },
  },
};
</script>

<style>
</style>

          